import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-blog-details-two',
  templateUrl: './blog-details-two.component.html',
  styleUrls: ['./blog-details-two.component.scss']
})
export class BlogDetailsTwoComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
